<script setup>
/******************************************************************************
 * PageComponent: ReadingReq
 *****************************************************************************/
import { useReadingStore } from "Stores/reading";
import ReadingReqCustomer from "./ReadingReqCustomer.vue";
const data = useReadingStore();
const customers = data.customers.filter((customer) => {
    return customer.readingReqChannel !== 999;
});
</script>

<template>
    <section class="output-channel">
        <header>
            <h2>
                Sie möchten Ihre Ableseaufforderung zukünftig per E-Mail
                erhalten?
            </h2>
        </header>
        <p>
            Kein Problem – tragen Sie einfach Ihre E-Mail-Adresse in das
            untenstehende Feld ein.<br />
            Künftig senden wir Ihnen die Ableseaufforderung bequem per E-Mail
            zu.
        </p>
        <ul class="customers">
            <reading-req-customer
                v-for="customer in customers"
                :key="customer.customerId"
                :customer="customer"
            />
        </ul>
    </section>
</template>

<style lang="scss" scoped>
.output-channel {
    padding: #{get($sizes, "base")};
    margin-top: #{get($sizes, "base") * 1};

    background-color: get($client, "outputChannelBg");
    color: get($client, "outputChannelColor");
    border-radius: get($sizes, "radius");

    @include respond-to("medium") {
        margin-top: #{get($sizes, "base") * 2};
    }

    h2 {
        padding: 0 0 #{get($sizes, "base") * 0.6} 0;
        border-bottom: get($client, "appBorder");
        margin: 0 0 #{get($sizes, "base") * 0.6} 0;

        color: get($client, "outputChannelColor");

        font-size: #{get($sizes, "base") * 1.5};
        font-weight: 400;

        @include respond-to("medium") {
            margin: 0 0 #{get($sizes, "base") * 1.2} 0;
        }
    }
}

.customers {
    display: flex;
    flex-direction: column;

    padding: 0;
    margin: #{get($sizes, "base") * 1} 0 0 0;
    gap: #{get($sizes, "base") * 1};

    list-style: none;

    @include respond-to("medium") {
        gap: #{get($sizes, "base") * 1.5};
    }
}
</style>
